<template>
  <div class="holidayHistory">
    <Header title="教室借用审核详情"></Header>

    <NOdata
      v-if="this.list && this.list.length <= 0"
      title="未查询到教室借用审核详情"
    ></NOdata>
    <ul class="content">
      <li :class="item.class" v-for="(item, index) in list" :key="index">
        <div class="date">
          {{ item.shsj }}
        </div>
        <div class="bar"></div>
        <div class="club">
          <span>{{ item.bzname }}</span>
          <span class="state">
            {{ item.shzt == "" ? "待审核" : item.shzt }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      list: [],
      dqshr: ""
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const res = await Api.getlcShjl({
        ywinstanceid: this.$route.query.ywinstanceid
      });
      this.list = res.lcbz;
      this.list.forEach(item => {
        item.class = "clearfix";
        if (item.shzt == "通过") {
          item.class += " ytg";
        } else if (item.shzt == "不通过") {
          item.class += " btg";
        } else if (item.shzt == "审核中") {
          item.class += " shz";
        } else if (item.shzt == "流程终止") {
          item.class += " zzlc";
        } else {
          item.class += " dsh";
        }
      });

      this.dqshr = res.dqshr;
    }
  }
};
</script>
<style lang="less" scoped>
.clearfix::before,
.clearfix::after {
  content: "";
  display: table;
}
.clearfix::after {
  clear: both;
}
.clearfix {
  *zoom: 1;
}
.content {
  padding: 0 0 20px 20px;
  li {
    margin-bottom: 20px;
    div {
      display: inline-block;
      float: left;
      margin-right: 12px;
    }
    .date {
      width: 82px;
      height: 77px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      letter-spacing: 0;
      text-align: center;
      font-weight: bold;
    }
    .bar {
      width: 4px;
      height: 77px;
      border-radius: 8px;
    }
    .club {
      height: 77px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      letter-spacing: 0;
      font-weight: bold;
      display: inline-flex;
      flex-direction: column;
      justify-content: space-between;
      .state {
        font-family: PingFangSC-Regular;
        font-weight: normal;
        font-size: 12px;
        letter-spacing: 0;
      }
    }
  }
  .shz {
    div {
      color: #cd4e41;
    }
    .bar {
      background: #cd4e41;
    }
  }
  .ytg {
    div {
      // color: #3b82ff;
      color: #000;
    }
    .bar {
      background: #000;
    }
  }
  .btg {
    div {
      color: #a2a2a2;
    }
    .bar {
      background: #a2a2a2;
    }
  }
  .dsh {
    div {
      color: #a2a2a2;
    }
    .bar {
      background: #a2a2a2;
    }
  }
  .zzlc {
    div {
      color: #000;
    }
    .bar {
      background: #000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/roomBorrow/historyList_10534.vue